import { c as _c } from "react/compiler-runtime";
import { Button, Tooltip } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import useRefocusOnRemoval from '../../hooks/use-refocus-on-removal';
type DecryptAction = {
  canDecrypt: boolean;
  isDecrypting: boolean;
  onDecrypt: () => void;
};
type DecryptAllButtonProps = {
  decrypt: DecryptAction;
  /** Takes focus when the button goes while focused, like once nothing is left encrypted. */
  onRemovedWhileFocused: () => void;
  className?: string;
};
const DecryptAllButton = t0 => {
  const $ = _c(16);
  const {
    decrypt,
    onRemovedWhileFocused,
    className
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "onboardings"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  const focusHandlers = useRefocusOnRemoval(onRemovedWhileFocused);
  const t2 = decrypt.canDecrypt;
  let t3;
  if ($[1] !== t) {
    t3 = t(_temp);
    $[1] = t;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = !decrypt.canDecrypt;
  const t5 = decrypt.isDecrypting;
  const t6 = decrypt.onDecrypt;
  let t7;
  if ($[3] !== t) {
    t7 = t(_temp2);
    $[3] = t;
    $[4] = t7;
  } else {
    t7 = $[4];
  }
  let t8;
  if ($[5] !== className || $[6] !== decrypt.isDecrypting || $[7] !== decrypt.onDecrypt || $[8] !== focusHandlers || $[9] !== t4 || $[10] !== t7) {
    t8 = <Button size="compact" className={className} disabled={t4} loading={t5} onClick={t6} {...focusHandlers}>{t7}</Button>;
    $[5] = className;
    $[6] = decrypt.isDecrypting;
    $[7] = decrypt.onDecrypt;
    $[8] = focusHandlers;
    $[9] = t4;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== decrypt.canDecrypt || $[13] !== t3 || $[14] !== t8) {
    t9 = <Tooltip disabled={t2} content={t3}>{t8}</Tooltip>;
    $[12] = decrypt.canDecrypt;
    $[13] = t3;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  return t9;
};
export type { DecryptAction };
export default DecryptAllButton;
function _temp($) {
  return $.decryptPermissionError;
}
function _temp2($_0) {
  return $_0.userData.decrypt.decryptAll;
}